import { render, staticRenderFns } from "./BaseSendNotificationDialog.vue?vue&type=template&id=508e701c&"
import script from "./BaseSendNotificationDialog.vue?vue&type=script&lang=js&"
export * from "./BaseSendNotificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports